import { ReactNode } from 'react'
import LandingFrame from '../assets/checker/LandingFrame.png'

interface AuthContainerProps {
  children: ReactNode
}

export default function AuthContainer({ children }: AuthContainerProps) {
  return (
    <section className='h-[calc(100vh-64px)] md:h-[calc(100vh-72px)] relative bg-[#ECECEC] mx-4 md:mx-6 lg:mx-10 my-4 md:my-6 lg:my-8 rounded-[16px] md:rounded-[20px] overflow-hidden flex items-center snap-start'>
      {/* Mobile Background Image */}
      <div 
        className='lg:hidden absolute inset-0 bg-no-repeat bg-cover bg-center opacity-20'
        style={{
          backgroundImage: `url(${LandingFrame})`,
        }}
      />
      
      <div className='w-full flex flex-col lg:flex-row items-center justify-between px-6 md:px-10 lg:pl-16 lg:pr-0 py-8 md:py-12 lg:py-0 relative z-10 h-full'>
        {/* Left Content - Flexible for Auth Forms */}
        <div className='flex-shrink-0 w-full lg:max-w-[600px] h-full flex items-center justify-center lg:justify-start'>
          <div className='w-full max-w-[500px]'>
            {children}
          </div>
        </div>

        {/* Right Content - Image (larger and blended into corners) - Desktop Only */}
        <div className='hidden lg:flex flex-1 items-center justify-end relative -mt-8 -mb-8 -mr-[20px]'>
          <img 
            src={LandingFrame} 
            alt='Background check showcase' 
            className='w-full max-w-[850px] h-auto object-contain scale-[1.2]'
          />
        </div>
      </div>
    </section>
  )
}
